var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7881 15.4448C11.0803 15.4448 11.3193 15.2058 11.3193 14.9136V5.35107H8.66309C8.07539 5.35107 7.60059 4.87627 7.60059 4.28857V1.63232H2.28809C1.9959 1.63232 1.75684 1.87139 1.75684 2.16357V14.9136C1.75684 15.2058 1.9959 15.4448 2.28809 15.4448H10.7881ZM0.163086 2.16357C0.163086 0.991504 1.11602 0.0385742 2.28809 0.0385742H7.7832C8.34766 0.0385742 8.88887 0.261035 9.2873 0.659473L12.2922 3.66436C12.6906 4.06279 12.9131 4.604 12.9131 5.16846V14.9136C12.9131 16.0856 11.9602 17.0386 10.7881 17.0386H2.28809C1.11602 17.0386 0.163086 16.0856 0.163086 14.9136V2.16357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemNumber);
export default __webpack_public_path__ + "static/media/item-number.ebbc52fb7b66e61dafa51d28c3c60de5.svg";
export { ForwardRef as ReactComponent };